import React from 'react';
import SEOPageService from '../../../services/contentful/SEOPageService';
import menuAndFooterService from '../../../services/contentful/menuAndFooterService';
import SeoPageTemplate from '../../../components/Organisms/SEOPageTemplate';
import RedirectionService from '../../../services/api/RedirectionService';

const Level2Page = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SeoPageTemplate {...props} />
);

export default Level2Page;

export async function getServerSideProps({ params }) {
  let pageContent;
  let menuAndFooter;
  let siblings;
  let parent;

  try {
    menuAndFooter = await menuAndFooterService.menuAndFooter();
  } catch (err) {
    menuAndFooter = {};
    console.error(err);
  }
  try {
    const parentSlug = params?.level1;
    const currentSlug = `${params?.level1}/${params?.level2}`;
    const currentPage = await SEOPageService.pageContent(currentSlug);
    pageContent = currentPage?.items?.[0];
    const allContents = await SEOPageService.pageContents(`${parentSlug}/`);

    if (!pageContent || !pageContent?.fields) {
      const redirection = await RedirectionService.getRedirection(`${params.level1}/${params.level2}`);
      return {
        redirect: {
          destination: '/' + (redirection?.data?.destination_slug || '404'),
          permanent: false,
        },
      };
    }
    parent = allContents?.items?.reduce((acc, { fields }) => {
      if (fields?.slug === parentSlug) {
        return fields;
      }
      return acc;
    }, {});
    siblings = allContents?.items?.reduce((acc, { fields }) => {
      // If items has the same parent and is not the current page
      if (fields?.slug?.includes(parentSlug + '/') && !fields?.slug.includes(params?.level2)) {
        // Keep only level 2 elements
        if (fields?.slug.split('/').length === 2) {
          return [...acc, fields];
        }
      }
      return acc;
    }, []);
  } catch (err) {
    pageContent = null;
    siblings = [];
    parent = null;
    console.error(err);
  }

  if (!pageContent?.fields) {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
      },
    };
  }

  return {
    props: {
      pageContent: pageContent?.fields || null,
      siblings: siblings?.sort(() => 0.5 - Math.random()).slice(0, 5),
      parents: [parent],
      ...menuAndFooter?.fields,
    },
  };
}
